 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		29: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		29: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"09ff7e95dd83ed95cbc62799256a0ba6b96f19bb","3":"8e2c5b87d23f2fcafb6a6db1f3ddd7a957529b67","5":"component---src-pages-about-js","6":"component---src-pages-acjpatun-js","7":"component---src-pages-case-1-js","8":"component---src-pages-case-10-js","9":"component---src-pages-case-11-js","10":"component---src-pages-case-12-js","11":"component---src-pages-case-13-js","12":"component---src-pages-case-14-js","13":"component---src-pages-case-15-js","14":"component---src-pages-case-16-js","15":"component---src-pages-case-2-js","16":"component---src-pages-case-3-js","17":"component---src-pages-case-4-js","18":"component---src-pages-case-5-js","19":"component---src-pages-case-6-js","20":"component---src-pages-case-7-js","21":"component---src-pages-case-8-js","22":"component---src-pages-case-9-js","23":"component---src-pages-cases-js","24":"component---src-pages-community-js","25":"component---src-pages-index-js","26":"component---src-pages-manifesto-js","27":"component---src-pages-reportsanddata-js"}[chunkId]||chunkId) + "-" + {"0":"15fc544d0da4a1c817f9","1":"823ae8103e36ae8a7f9f","2":"2a0cf5241a52ce49075a","3":"7ffc2502e37fee4b1903","5":"3b6af85fb57790d9a440","6":"bfcad834dd75b5268d95","7":"98a89c767f93938c9833","8":"ce48b8a7bafe77bfc5b9","9":"6c18b358c6c3f6421761","10":"2b7d3f28ec63ee387c59","11":"7a312ed39ba1b9ddace2","12":"8cb19f03a45604393012","13":"6ec6ceeba4d0b97d6107","14":"17b343edf9f6b9fc2c4c","15":"051271043029b8d5e2c5","16":"20c119373403c5c51ad1","17":"9f87e248d57f2712422d","18":"9ea14288a22373126837","19":"e9f6d31a4e789e4a2786","20":"169ef6d3217f967b7d9b","21":"49145d58e307536f90f4","22":"28d861e35946c56c90e3","23":"418760c66cf3bb23a21a","24":"fbb71f1d03f24b35f1da","25":"ff3ac0b6ee797226a9aa","26":"787b05837ca75a0d1a76","27":"2119b7a1096f748767ef"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"09ff7e95dd83ed95cbc62799256a0ba6b96f19bb","3":"8e2c5b87d23f2fcafb6a6db1f3ddd7a957529b67","5":"component---src-pages-about-js","6":"component---src-pages-acjpatun-js","7":"component---src-pages-case-1-js","8":"component---src-pages-case-10-js","9":"component---src-pages-case-11-js","10":"component---src-pages-case-12-js","11":"component---src-pages-case-13-js","12":"component---src-pages-case-14-js","13":"component---src-pages-case-15-js","14":"component---src-pages-case-16-js","15":"component---src-pages-case-2-js","16":"component---src-pages-case-3-js","17":"component---src-pages-case-4-js","18":"component---src-pages-case-5-js","19":"component---src-pages-case-6-js","20":"component---src-pages-case-7-js","21":"component---src-pages-case-8-js","22":"component---src-pages-case-9-js","23":"component---src-pages-cases-js","24":"component---src-pages-community-js","25":"component---src-pages-index-js","26":"component---src-pages-manifesto-js","27":"component---src-pages-reportsanddata-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"08830f240cbe75cc2f63","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
